import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import * as S from './styles';

const msgs = defineMessages({
  label: {
    id: 'wordlists_viewscreen_card_badge',
  },
});

export const CommunityWordlistBadge: FC = () => {
  const intl = useIntl();
  const label = intl.formatMessage(msgs.label);

  return <S.Badge data-testid="wordlist_community_label">{label}</S.Badge>;
};
